<template>
  <div :id="id" class="w-max">
    <div class="cursor-pointer" @click="handleIconClick()">
      <aha-icon
        name="kebab-menu"
        width="18"
        height="18"
        viewBox="0 0 14 14"
      />
    </div>
    <aha-context-menu
      ref="context-menu"
      :target="id"
      :x="targetX"
      :y="targetY"
    >
      <aha-context-menu-header>
        <span class="text-base-60">{{ memberIndex + 1 }}. </span>
        <span class="font-bold">{{ member.firstName }} {{ member.lastName }}</span>
      </aha-context-menu-header>

      <aha-context-menu-item
        @click="$emit('openConfirmRemoveMember', member)"
        v-if="(member.email !== currentUser.email) && currentUserIsTeamOwnerOrAdmin"
      >
        <aha-svg class="text-secondary-40 hover:text-secondary-50" name="delete" />
        <span>{{ $i18nPresenter.t('Remove from team') }}</span>
      </aha-context-menu-item>
      <aha-context-menu-item
        @click="$emit('openConfirmLeaveTeam', member)"
        v-if="(member.email === currentUser.email) && isSelfCreateTeam && !hasOnboardingV3"
      >
        <aha-svg class="text-secondary-40 hover:text-secondary-50" name="logout" />
        <span>{{ $i18nPresenter.t('Leave team') }}</span>
      </aha-context-menu-item>
      <aha-context-menu-item @click="openViewDetail()">
        <aha-svg
          class="mt-1 text-secondary-40"
          name="info-circle"
          viewBox="0 0 24 24"
          width="22"
          height="22"
        />
        <span class="kebab__view-detail">{{ $i18nPresenter.t('View detail') }}</span>
      </aha-context-menu-item>
    </aha-context-menu>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import utils from '@/util'
import eventCategories from '@/constant/eventCategories'

export default {
  props: {
    member: {
      type: Object,
      default: () => {},
    },
    memberIndex: {
      type: Number,
      default: null,
    },
    id: {
      type: String,
      default() {
        return Math.random().toString().substring(7)
      },
    },
    currentUserIsTeamOwnerOrAdmin: {
      type: Boolean,
      default: false,
    },
    isSelfCreateTeam: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      targetX: null,
      targetY: null,
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
      hasOnboardingV3: (state) => state.indicators.hasOnboardingV3,
    }),
  },
  methods: {
    handleIconClick(exact) {
      if (!exact) {
        this.targetX = null
        this.targetY = null
      }
      this.$refs['context-menu'].show()
      utils.mixpanelTracking(eventCategories.MY_ACCOUNT, 'Team Kebab Menu > Open')
    },
    openViewDetail() {
      this.$emit('handleShowViewDetail')
    },
  },
}
</script>

<style lang="scss" scoped>
.kebab__view-detail {
  margin-left: 0.1rem !important;
}
</style>
